import { touchElementP } from './touchElementP';
export function touchAllP(selectors, scope) {
    if (scope === void 0) { scope = document; }
    return Promise.all(selectors.map(function (selector) { return touchElementP(selector, scope); }));
}
